export const LABELS = {
  remediationValidation: 'Remediation Validation',
};